export default {"src":"/_next/static/media/blue_rays.f488dff4.gif","height":700,"width":1200,"blurWidth":0,"blurHeight":0};